export default __webpack_public_path__ + "22a494e89f608dd690bf23b6febc6326.otf";